export const EMPTY_COLUMN_IDS: readonly string[] = [];

export const HEADER_ACTION_WIDTH = 56;

export const visuallyHidden = {
  border: 0,
  padding: 0,
  width: '1px',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  clip: 'rect(0 0 0 0)',
} as const;
